export const APP_LANGUAGES = [
  { code: 'en', name: 'English', nativeName: 'English', flag: '🇺🇸' },
  { code: 'fr', name: 'French', nativeName: 'Français', flag: '🇫🇷' },
  { code: 'es', name: 'Spanish', nativeName: 'Español', flag: '🇪🇸' },
  { code: 'de', name: 'German', nativeName: 'Deutsch', flag: '🇩🇪' },
  { code: 'it', name: 'Italian', nativeName: 'Italiano', flag: '🇮🇹' },
  { code: 'zh-CN', name: 'Chinese (Mandarin)', nativeName: '中文 (简体)', flag: '🇨🇳' },
  { code: 'zh-TW', name: 'Chinese (Cantonese)', nativeName: '中文 (繁體)', flag: '🇹🇼' },
  { code: 'ar', name: 'Arabic', nativeName: 'العربية', flag: '🇸🇦' },
];

export const resolveAppLanguage = (value) => {
  const code = String(value || 'en');
  if (APP_LANGUAGES.some((language) => language.code === code)) return code;
  const base = code.split('-')[0];
  return APP_LANGUAGES.find((language) => language.code === base)?.code || 'en';
};
